import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _brandkit = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _createBrandkitRequest = { brandkit: '_brandkit' };
var _createBrandkitResponse = { brandkit: '_brandkit' };
var _deleteBrandkitRequest = {};
var _deleteBrandkitResponse = {};
var _extractBrandkitWithoutSavingRequest = {};
var _extractBrandkitWithoutSavingResponse = { brandkit: '_brandkit' };
var _extractBrandkitWithToneOfVoiceRequest = {};
var _extractBrandkitWithToneOfVoiceResponse = {};
var _generateToneOfVoiceRequest = {};
var _generateToneOfVoiceResponse = {};
var _getBrandkitRequest = {};
var _getBrandkitResponse = { brandkit: '_brandkit' };
var _queryBrandkitsRequest = {};
var _queryBrandkitsResponse = { brandkits: '_brandkit' };
var _updateBrandkitRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    brandkit: '_brandkit',
};
var _updateBrandkitResponse = { brandkit: '_brandkit' };
function resolveWixEnterpriseBrandkitV1BrandkitServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/brandkit-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a Brandkit. */
export function createBrandkit(payload) {
    var _a = serializer(_createBrandkitRequest, { _brandkit: _brandkit }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createBrandkitResponse, {
        _brandkit: _brandkit,
    }).fromJSON;
    function __createBrandkit(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.brandkit.v1.brandkit',
            method: 'POST',
            methodFqn: 'wix.enterprise.brandkit.v1.BrandkitService.CreateBrandkit',
            url: resolveWixEnterpriseBrandkitV1BrandkitServiceUrl({
                protoPath: '/v1/brandkits',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createBrandkit.fromReq = fromReq;
    __createBrandkit.__isAmbassador = true;
    return __createBrandkit;
}
/** Retrieves a Brandkit. */
export function getBrandkit(payload) {
    var _a = serializer(_getBrandkitRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getBrandkitResponse, { _brandkit: _brandkit }).fromJSON;
    function __getBrandkit(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.brandkit.v1.brandkit',
            method: 'GET',
            methodFqn: 'wix.enterprise.brandkit.v1.BrandkitService.GetBrandkit',
            url: resolveWixEnterpriseBrandkitV1BrandkitServiceUrl({
                protoPath: '/v1/brandkits/{brandkitId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getBrandkit.fromReq = fromReq;
    __getBrandkit.__isAmbassador = true;
    return __getBrandkit;
}
/** Updates a Brandkit. */
export function updateBrandkit(payload) {
    var _a = serializer(_updateBrandkitRequest, { _brandkit: _brandkit }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateBrandkitResponse, {
        _brandkit: _brandkit,
    }).fromJSON;
    function __updateBrandkit(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.brandkit.v1.brandkit',
            method: 'PATCH',
            methodFqn: 'wix.enterprise.brandkit.v1.BrandkitService.UpdateBrandkit',
            url: resolveWixEnterpriseBrandkitV1BrandkitServiceUrl({
                protoPath: '/v1/brandkits/{brandkit.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateBrandkit.fromReq = fromReq;
    __updateBrandkit.__isAmbassador = true;
    return __updateBrandkit;
}
/** Deletes a Brandkit. */
export function deleteBrandkit(payload) {
    var _a = serializer(_deleteBrandkitRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteBrandkitResponse, {}).fromJSON;
    function __deleteBrandkit(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.brandkit.v1.brandkit',
            method: 'DELETE',
            methodFqn: 'wix.enterprise.brandkit.v1.BrandkitService.DeleteBrandkit',
            url: resolveWixEnterpriseBrandkitV1BrandkitServiceUrl({
                protoPath: '/v1/brandkits/{brandkitId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteBrandkit.fromReq = fromReq;
    __deleteBrandkit.__isAmbassador = true;
    return __deleteBrandkit;
}
/**
 * Retrieves a list of Brandkits, given the provided [paging, filtering, and sorting][1].
 *
 * Up to 1,000 Brandkits can be returned per request.
 *
 * To learn how to query Brandkits, see [API Query Language][2].
 *
 * [1]: https://dev.wix.com/api/rest/getting-started/sorting-and-paging
 * [2]: https://dev.wix.com/api/rest/getting-started/api-query-language
 */
export function queryBrandkits(payload) {
    var _a = serializer(_queryBrandkitsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryBrandkitsResponse, {
        _brandkit: _brandkit,
    }).fromJSON;
    function __queryBrandkits(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.brandkit.v1.brandkit',
            method: 'POST',
            methodFqn: 'wix.enterprise.brandkit.v1.BrandkitService.QueryBrandkits',
            url: resolveWixEnterpriseBrandkitV1BrandkitServiceUrl({
                protoPath: '/v1/brandkits/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryBrandkits.fromReq = fromReq;
    __queryBrandkits.__isAmbassador = true;
    return __queryBrandkits;
}
/** Extract Brandkit from site without saving in db */
export function extractBrandkitWithoutSaving(payload) {
    var _a = serializer(_extractBrandkitWithoutSavingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_extractBrandkitWithoutSavingResponse, { _brandkit: _brandkit }).fromJSON;
    function __extractBrandkitWithoutSaving(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.brandkit.v1.brandkit',
            method: 'POST',
            methodFqn: 'wix.enterprise.brandkit.v1.BrandkitService.ExtractBrandkitWithoutSaving',
            url: resolveWixEnterpriseBrandkitV1BrandkitServiceUrl({
                protoPath: '/v1/brandkit-extractor/without-saving',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __extractBrandkitWithoutSaving.fromReq = fromReq;
    __extractBrandkitWithoutSaving.__isAmbassador = true;
    return __extractBrandkitWithoutSaving;
}
/** Brandkit extraction from site with tone of voice */
export function extractBrandkitWithToneOfVoice(payload) {
    var _a = serializer(_extractBrandkitWithToneOfVoiceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_extractBrandkitWithToneOfVoiceResponse, {}).fromJSON;
    function __extractBrandkitWithToneOfVoice(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.brandkit.v1.brandkit',
            method: 'POST',
            methodFqn: 'wix.enterprise.brandkit.v1.BrandkitService.ExtractBrandkitWithToneOfVoice',
            url: resolveWixEnterpriseBrandkitV1BrandkitServiceUrl({
                protoPath: '/v1/brandkit-extractor-tov',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __extractBrandkitWithToneOfVoice.fromReq = fromReq;
    __extractBrandkitWithToneOfVoice.__isAmbassador = true;
    return __extractBrandkitWithToneOfVoice;
}
/** Brandkit tone of voice */
export function generateToneOfVoice(payload) {
    var _a = serializer(_generateToneOfVoiceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_generateToneOfVoiceResponse, {}).fromJSON;
    function __generateToneOfVoice(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.brandkit.v1.brandkit',
            method: 'POST',
            methodFqn: 'wix.enterprise.brandkit.v1.BrandkitService.GenerateToneOfVoice',
            url: resolveWixEnterpriseBrandkitV1BrandkitServiceUrl({
                protoPath: '/v1/generate-tov',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __generateToneOfVoice.fromReq = fromReq;
    __generateToneOfVoice.__isAmbassador = true;
    return __generateToneOfVoice;
}
//# sourceMappingURL=http.impl.js.map